import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/ts/L10n/L10n';

import {
  ICreatedItemInfo,
  IExplorableItemTypeInfo,
  IIdItemInfo,
} from '../../ts/models/resourceInfoParts';

export interface IConnectedApplicationInfo extends IExplorableItemTypeInfo<'connectedApplication'>, IIdItemInfo, ICreatedItemInfo {
  enabled: boolean;
  projectId?: string;
  domainSafelist?: string; // space-delimited
  unrestrictedEmbedding?: boolean;
  domainSafelistForGrid?: string;
}

export function localizeConnectedApplicationDomainSafelist(domains?: string) {
  if (domains === undefined) {
    return Messages.connectedApplicationsDomainsAll();
  }
  if (domains.trim() === '') {
    return Messages.connectedApplicationsDomainsNone();
  }
  const numDomains = domains.split(' ').length;
  return Messages.connectedApplicationsDomainsNumber({
    DOMAIN_COUNT_LOC: L10n.localizedCount(numDomains),
  });
}